import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import EstimateList from '../components/estimates/EstimateList';
import EstimateForm from '../components/estimates/EstimateForm';
import './Estimates.css';

/**
 * Estimates Page Component
 * 
 * Main page for managing estimates. Displays a list of existing estimates and
 * provides an interface to create new ones.
 */
const Estimates = () => {
  // State for UI control
  const [showForm, setShowForm] = useState(false);
  const [refreshListTrigger, setRefreshListTrigger] = useState(0);
  
  /**
   * Handle estimate creation completion
   * Called when a new estimate has been created or the form is cancelled
   */
  const handleEstimateCreated = () => {
    setShowForm(false); // Hide the form after estimate is created
    setRefreshListTrigger(prev => prev + 1); // Trigger a refresh of the EstimateList
  };
  
  return (
    <div className="estimates-page-wrapper">
      <Container fluid>
        <Row className="mb-4 align-items-center estimates-page-header">
          <Col>
            <h2 className="estimates-page-title">Estimates</h2>
          </Col>
          <Col xs="auto">
            <Button
              variant="primary"
              className="estimates-new-btn"
              onClick={() => setShowForm(prev => !prev)}
            >
              {showForm ? 'Cancel' : <><FaPlus className="me-2" /> New Estimate</>}
            </Button>
          </Col>
        </Row>

        {showForm ? (
          <Row className="mb-4">
            <Col>
              <EstimateForm
                onEstimateCreated={handleEstimateCreated}
                onCancel={() => setShowForm(false)}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <Card className="estimates-card">
                <Card.Header>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Estimate List</span>
                  </div>
                </Card.Header>
                <Card.Body>
                  <EstimateList
                    refreshTrigger={refreshListTrigger}
                    onCreateClick={() => setShowForm(true)}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Estimates;